// Enums for configuration values
export const GamePageVersion = {
  GURSHA: 'gursha',
  HULU: 'hulu',
  HABTAM: 'habtam',
};

export const MobileNavBarVersion = {
  HULUSPORT: 'HULUSPORT',
  GURSHAFOOTER: 'GURSHAFOOTER',
  LEGACY: 'legacy',
  JANO: 'jano',
};

export const RightBarVersion = {
  BETMAN: 'BETMAN',
  GURSHA: 'GURSHA',
  LEGACY: 'legacy',
  JANO: 'JANO',
};

export const MarketMobileVersion = {
  VARIANT1: 'variant1',
  VARIANT2: 'variant2',
  JANO: 'jano', //  three-way market
  FRANK: 'frank',
};

export const DateTimeFilterTemplate = {
  LEGACY_FILTER: 'LegacyDayFilter',
  DATETIME_FILTER: 'DateTimeFilter',
  ZEMEN_DATE_FILTER: 'ZemenDayFilter',
};

export const MobileDepositTemplate = {
  SOCCER: 'Soccer',
  ZEMEN: 'Zemen',
};

export const BetMatchListTemplate = {
  LEGACY: 'Legacy',
  GURSHA: 'GURSHA',
};

export const PromotionVersion = {
  PROMO_LIST: '/promotion',
  NEW_REWARDS: '/my-awards-and-promotions',
};

export const appThemeConfiguration = {
  // App/Theme Configuration
  FAVICON: 'logo.png',
  TITLE: 'Convexit',
  THEME: '',
  LOADING_LOGO: 'logo.png',

  // Logo and Stake Settings
  LOGO_SIZE: 16,
  LOGO_SIZE_MOBILE: 9,
  MIN_STAKE: 20,
  MAX_STAKE: 5000,

  // UI/UX Settings
  ENABLE_SLIP_NAV: false,
  RIGHTBAR_SCROLL: false,
  TICKET_SCROLL: false,
  STICKY_BANNER: false,
  SCROLLABLE_HOME: false,
  STICKY_HEADER: false,

  // Game Settings
  SHOW_GAMES_SIDEBAR: true,
  SWAP_SPORT_TYPE_DATE_FILTER: true,
  SHOW_GAME_ID: true,
  ENABLE_DOUBLE_CHANCE_DESKTOP: true,
  ENABLE_DOUBLE_CHANCE_MOBILE: true,

  // Display Settings
  IS_LOCAL_TIME: true,
  ABBREVIATE: false,
  MATCHNAME_ONELINE: false,
  ODD_DIVIDER: false,
  TICKET_ROUNDED: false,
  TICKET_HIGHLIGHTED: true,
  SHOW_MULA_FOOTER: true,
  MOBILE_BOTTOM_TAB_INFO: false,
  MATCH_DETAIL_ADD_TO_SLIP_REDIRECT_TO_MATCH_LIST: true,
  MATCH_HEADER_ABBREVIATE: false,
  MATCH_EVENT_TITLE_SHOW_WAY: false,

  // Feature Flags
  DISABLE_FETAN_LEAGUE: false,
  KIRON_GAMES_TAG_SLUG: 'kironlite-games',
  DISABLE_HOME_MOBILE: false,
  DISABLE_AM_LANG: false,
  DISABLE_MATCH_VIEW_TYPE: true,
  SHOW_GAME_MODE_OPTION: true,
  SHOW_FLOATING_SOCIAL_MEDIA: false,
  DISPLAY_GET_BOUNS_ALERT: false,
  DISPLAY_DEPOSIT_ALERT: true,
  ENABLE_CHAPA_DIRECT: true,

  // Version Settings
  GAME_PAGE_VERSION: GamePageVersion.GURSHA,
  BET_MATCH_LIST_TEMPLATE: BetMatchListTemplate.GURSHA,
  MOBILE_NAV_BAR_VERSION: MobileNavBarVersion.GURSHAFOOTER,
  RIGHT_BAR: RightBarVersion.LEGACY,
  MARKET_MOBILE_VERSION: MarketMobileVersion.VARIANT1,

  MOBILE_SEARCH: false,
  ENABLE_CASHOUT: true,
  GAMES_IS_HOME: false,

  // Form Settings
  BIRTH_DATE: false,
  ISSUE_DATE: false,
  EXPIRE_DATE: false,
  INLINE_BET_DATA_VIEW: false,
  VIEW_COUPON_IN_NEW_PAGE: true,
  NAV_ICON_HIGHLIGHT: true,

  FIXED_MATCH_DETAIL_HEADER: false,
  MOBILE_DEPOSIT_TEMPLATE: MobileDepositTemplate.SOCCER,

  // Aggregator Settings
  AGGREGATOR_ORDER: ['chappa', 'arifpay', 'santim'],

  // New Features
  FREEBET_VERSION: false,
  ENABLE_LUCKY_WHEEL: false,
  ENABLE_PLACEBET_BONUS: false,
  ENABLE_RAFFLE_FEATURE: true,
  PROMOTION_PAGE_PATH: PromotionVersion.NEW_REWARDS,

  // Tracking Settings
  TAWK_ID: '',
  GOOGLE_TRACKING_ID: 'G-QBWN5GZG6V',
  GOOGLE_ANALYTICS_ID: 'null',
  GENIUS_TRACKING_ID: '',
  GENIUS_CLIENT_PREFIX: '',

  // Filtering Settings
  DATE_FILTER: true,
  SPORT_TYPE_FILTER: false,
  APP_HOUR_DATE_FILTERING: true,
  DATETIME_FILTER_TEMPLATE: DateTimeFilterTemplate.ZEMEN_DATE_FILTER,

  AD_CLICK_ID_TRACKER: false,

  // DIALOG MANAGER ORDER
  POPUP_MANAGER_ORDER: [
    'RAFFLE_RESULT',
    'TOURNAMENT_POPUP',
    'AFFILIATE_POPUP',
    'INSUFFICIENT',
  ],
  CLOUDFLARE_KEY: null,
};
